/**
 * Every blueprint, by assessment, in one place.
 *
 * The blueprint hook, the create flow and the paper-section builder each read
 * and wrote this key in their own way (one with an envelope, two without), so a
 * blueprint made at creation could be missing when the page opened. They all go
 * through this store now.
 */

import { createPersistedStore } from "@/lib/persisted-store"

import { ASSESSMENT_BLUEPRINT_STORE_KEY, type AssessmentBlueprintStore } from "./storage"

export const blueprintStore = createPersistedStore<AssessmentBlueprintStore>(
  ASSESSMENT_BLUEPRINT_STORE_KEY,
  () => ({}),
  {
    // Written before the store existed: a plain map of assessment id to blueprint.
    legacy: (parsed) =>
      parsed && typeof parsed === "object" && !("v" in (parsed as object))
        ? (parsed as AssessmentBlueprintStore)
        : undefined,
  },
)
